import { Component, Input, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { GetDeviceRequest } from 'libs/portal/src/models/GetDeviceRequest';
import { Notes } from 'libs/portal/src/models/Notes';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { ToolsService } from 'libs/portal/src/services/tools/tools.service';
import { UserRightsService } from 'libs/portal/src/services/user-rights/user-rights.service';
import { Endpoints } from '@huge-monorepo/portal/config';
@Component({
  selector: 'app-chat-popup',
  templateUrl: './chat-popup.component.html',
  styleUrls: ['./chat-popup.component.scss'],
})
export class ChatPopupComponent implements OnInit, OnDestroy {
  @Input() request: GetDeviceRequest;
  isCDR: boolean;
  @Output() closeChatModalEvent = new EventEmitter<any>();
  deviceNotes: Notes[] = [];
  userId = 0;
  newNote = '';
  showSpinner = false;
  deviceId: number;
  intervalListener: NodeJS.Timeout;
  localRequest: GetDeviceRequest;

  formGroup: UntypedFormGroup = new UntypedFormGroup({
    searchControl: new UntypedFormControl('', []),
  });

  constructor(
    private genericService: GenericService,
    private auth: UserRightsService,
    private endpoints: Endpoints,
    private activatedRoute: ActivatedRoute,
    private tools: ToolsService,
  ) {}

  ngOnInit() {
    this.userId = this.auth.GetUID();

    const temp = JSON.stringify(this.request);
    this.localRequest = JSON.parse(temp);

    if (this.request.KaID > 0) {
      this.isCDR = false;
      this.deviceId = this.request.KaID;
    } else if (this.request.CdrID > 0) {
      this.isCDR = true;
      this.deviceId = this.request.CdrID;
    }

    this.getNotes();
    this.intervalListener = setInterval(() => {
      this.getNotesCallback();
    }, 30000);
    // this.activatedRoute.queryParams.subscribe(params => {
    //   if (params.cdr != null) {
    //     this.isCDR = params.cdr === "true";
    //   }
    // });
  }

  // Callback function for the interval
  getNotesCallback() {
    this.getNotes();
  }

  ngOnDestroy(): void {
    if (this.intervalListener) {
      clearInterval(this.intervalListener);
    }
  }

  getNotes() {
    if (this.localRequest != null && this.deviceId > 0) {
      this.showSpinner = true;
      this.genericService.GET(this.endpoints.GET_NOTES(this.deviceId, false, '', this.isCDR)).subscribe((resp: Notes[] | any) => {
        this.deviceNotes = resp['body'] != null ? resp['body'].reverse() : [];
        this.deviceNotes.forEach((note) => {
          note.Timestamp = this.tools.FormatDateTimeFromDate(this.tools.ParseAPIDateWithTimezone(note.Timestamp));
        });
        console.log(this.deviceNotes);
        this.showSpinner = false;
      });
    }
  }

  closeChatModal($event: any) {
    this.closeChatModalEvent.emit($event);
  }

  clearNotesSearch() {
    this.formGroup.patchValue({
      searchControl: '',
    });
    this.searchNotes();
  }

  searchNotes() {
    const searchTerm = this.formGroup.get('searchControl')?.value;
    console.log('searchterm', searchTerm);
    if (searchTerm == '') {
      this.getNotes();
    } else if (this.deviceId != null) {
      this.showSpinner = true;
      this.genericService.GET(this.endpoints.SEARCH_NOTES(this.deviceId, false, '', searchTerm, this.isCDR)).subscribe((resp: Notes[] | any) => {
        this.deviceNotes = resp['body'] != null ? resp['body'].reverse() : [];
        this.deviceNotes.forEach((note) => {
          note.Timestamp = this.tools.FormatDateFromDate(this.tools.ParseAPIDate(note.Timestamp));
        });
        console.log(this.deviceNotes);
        this.showSpinner = false;
      });
    }
  }

  addNote() {
    const note = {
      Message: this.newNote,
      DeviceID: this.deviceId,
    };

    this.genericService.POST(this.endpoints.ADD_NOTE(this.deviceId, this.isCDR), note, true).subscribe((resp: any) => {
      this.deviceNotes.push(resp['body']);
    });

    this.newNote = '';
  }
}
